import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceState',
})
export class InvoiceStatePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    switch (value) {
      case 'PendingForComplianceCheck':
        return 'En attente de conformité';
      case 'NonCompliant':
        return 'Non conforme';
      case 'PendingForDuplicateCheck':
        return 'Conforme';
      case 'Duplicate':
        return 'Doublon';
      case 'PendingForQualificationCheck':
        return 'Non doublon';
      case 'NonQualified':
        return 'Non qualifiée';
      case 'NonQualifiedAfterCorrection':
        return 'Non qualifiée (après correction)';
      case 'PendingForEvaluaCheck':
        return 'En attente de contrôle sur eValua';
      case 'EvaluaControlOK':
        return 'Contrôle fournisseur eValua OK';
      case 'EvaluaControlKO':
        return 'Contrôle fournisseur eValua KO';
      case 'WaitingEvaluaCreate':
        return 'En attente de création fournisseur';
      case 'ExpensesCodeMissing':
        return 'En attente code famille à renseigner';
      case 'WaitingEvaluaExpenses':
        return 'En attente fournisseur et code famille';
      case 'EvaluaCreated':
        return 'Création fournisseur OK';
      case 'ExpensesCreated':
        return 'Création de famille de dépense OK';
      case 'Assigned':
        return 'Qualifiée';
      case 'AssignedAfterCorrection':
        return 'Qualifiée (après correction)';
      case 'SentBackToSupplier':
        return 'Portail fournisseur';
      case 'Processed':
        return 'Traitée';
      case 'PendingForWorkflowCompletion':
        return 'Traitée et en attente de validation';
      case 'PendingForWorkflowPromotionN1Completion':
        return 'En attente de validation N1 Promotion';
      case 'PendingForWorkflowPromotionN2Completion':
        return 'En attente de validation N2 Promotion';
      case 'PendingForWorkflowPromotionN3Completion':
        return 'En attente de BAP Promotion';
      case 'PendingForVoucherValidation':
        return 'En attente de traitement comptable';
      case 'PendingForPromotionValidation':
        return 'En attente de traitement comptable Promotion';
      case 'Validated':
        return 'Comptabilisé';
      case 'ValidatedPromotion':
        return 'Comptabilisé Promotion';
      case 'PartiallyPaidPromotion':
        return 'Partiellement réglée';
      case 'PaidPromotion':
        return 'Réglée';
      case 'ErrorPPR':
        return 'En erreur PPR';
      case 'CanceledPPR':
        return 'Annulée PPR';
      case 'Final':
        return 'Archivée';
      case 'Initial':
        return 'Injectée';
      case 'PendingForCreatePPRInvoice':
        return 'En attente de création de la facture dans PrimPromo';
      case 'InvoicePPRCreationSucceed':
        return 'Création de la facture dans PrimPromo avec succès';
      case 'InvoicePPRCreationFailed':
        return 'Echec de la création de la facture dans PrimPromo';
      case 'SituationPPRCreationSucceed':
        return 'Création de la situation dans PrimPromo avec succès';
      case 'SituationPPRCreationFailed':
        return 'Echec de la création de la situation dans PrimPromo';
      default:
        return value;
    }
  }
}
